import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

const FALLBACK = {
  committee_name: "Comitato Locale Orte Odv",
  logo_url: "",
  contact_email: "",
  show_hero: true,
  show_stats: true,
  show_filters: true,
  service_types: [],
  qualifications: [],
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...FALLBACK, ...data });
    } catch (e) {}
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, setSettings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
